import {LEAVE_TEAM_TOURNAMENT} from './types';

export const leaveTeamTournament = (teamId) => ({
  type: LEAVE_TEAM_TOURNAMENT.START,
  payload: {
    teamId,
  }
});
